import { useEffect, useState } from "react";
import { type SyncItem, api } from "../lib/api.ts";

interface Props {
  syncKey: string;
}

export default function Scripts({ syncKey }: Props) {
  const [items, setItems] = useState<SyncItem[]>([]);
  const [selected, setSelected] = useState<SyncItem | null>(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    setLoading(true);
    api.sync
      .scripts(syncKey)
      .then((r) => {
        setItems(r.items);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [syncKey]);

  const filtered = items.filter((i) => i.key.toLowerCase().includes(filter.toLowerCase()));

  return (
    <div className="page page--split">
      <div className="list-panel">
        <div className="list-panel__header">
          <h1>Plugins</h1>
          <input placeholder="Filter…" value={filter} onChange={(e) => setFilter(e.target.value)} />
        </div>
        {loading ? (
          <div className="loading">Loading…</div>
        ) : filtered.length === 0 ? (
          <div className="empty">
            No plugins synced yet. Run Solar Agent on your desktop to sync.
          </div>
        ) : (
          <ul className="item-list">
            {filtered.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  className={`item-list__row ${selected?.id === item.id ? "item-list__row--active" : ""}`}
                  onClick={() => setSelected(item)}
                >
                  <span className="item-key">{item.key.split("/").pop()}</span>
                  <span className="item-path">{item.key}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="detail-panel">
        {selected ? (
          <>
            <div className="detail-panel__header">
              <h2>{selected.key.split("/").pop()}</h2>
              <span className="item-path">{selected.key}</span>
            </div>
            <pre className="code-view">{selected.value}</pre>
          </>
        ) : (
          <div className="empty detail-empty">Select a plugin entry to view its source</div>
        )}
      </div>
    </div>
  );
}
